<template>
  <div>
    <!-- status-bar -->
    <div class="status-bar">
      <div class="status-block">
        <div class="status">기업용 기술신용평가 지원시스템</div>
        <!-- 로그인시 -->
        <ul v-if="isLogin">
          <!-- 게시판관리자 로그인시 -->
          <li v-if="isAdmin">
            <a href="/note_list_v2.do">[공지사항]</a>
          </li>
          <li v-if="isAdmin">
            <a href="/pds_list_v2.do">[자료실]</a>
          </li>

          <li>
            <a>
              <span class="glyphicon glyphicon-user"></span>
              <span v-if="isAdmin">게시판관리자 :</span>
              {{ getName }} ({{ getDesc }})
            </a>
          </li>
          <li>
            <a @click="logout">
              <span class="glyphicon glyphicon-log-out"></span> Logout
            </a>
          </li>
          <li>
            <a href="/mypage/pwcheck.do">
              <span class="glyphicon glyphicon-user"></span> Mypage
            </a>
          </li>
          <li>
            <a href="javascript:crFavorite('${contextPath}$');">
              <span class="glyphicon glyphicon-star"></span> Favorite
            </a>
          </li>
        </ul>
        <ul v-else>
          <!-- 로그아웃시 -->
          <li>
            <a href="/loginForm.do">
              <span class="glyphicon glyphicon-log-in"></span> Login
            </a>
          </li>
          <li>
            <a href="javascript:crFavorite('${contextPath}$');">
              <span class="glyphicon glyphicon-star"></span> Favorite
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- /status-bar -->

    <!-- gnb-wrap -->
    <div class="gnb-wrap">
      <div class="gnb-container">
        <div class="gnb-bi-wrap">
          <a href="/">
            <img src="@/assets/images/gotcb-ci.png" />
          </a>
        </div>
        <ul class="gnb-list-wrap">
          <li class="dropdown">
            <a @click="dropdown('information')" class="dropdown-toggle" data-toggle="dropdown">
              서비스안내
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-information">
              <li>
                <a href="/info/information10.do">서비스안내</a>
              </li>
              <li>
                <a href="/info/information1.do">자사 평가</a>
              </li>
              <li>
                <a href="/info/information2.do">대출용 평가</a>
              </li>
              <li>
                <a href="/info/information3.do">투자용 평가</a>
              </li>
              <li>
                <a href="/info/information4.do">특례상장 전문평가</a>
              </li>
              <li>
                <a href="/info/information5.do">조달청 제출용</a>
              </li>
              <li>
                <a href="/info/information6.do">기술가치 평가</a>
              </li>
              <li>
                <a href="/info/information9.do">데이터가치 평가</a>
              </li>
              <!-- 						<li><a href="/info/information7.do">우수기술인증서</a></li>  -->
              <!-- 						<li><a href="/info/information8.do">언론홍보대행서비스</a></li>  -->
            </ul>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li>
            <a href="/info/document.do">제출서류 안내</a>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li class="dropdown">
            <a @click="dropdown('form')" class="dropdown-toggle" data-toggle="dropdown">
              평가신청
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-form">
              <li>
                <a href="/ra_newForm_v2.do">기술평가신청</a>
              </li>
              <li>
                <a href="/ra_newForm_v2.do?newtype=value">기술가치평가 신청</a>
              </li>
              <li>
                <a href="/ra_newForm_v2.do?newtype=data">데이터가치평가 신청</a>
              </li>
              <!-- 						<li><a href="/ra_certnewForm_v1.do">우수기술인증서 신청</a></li> -->
            </ul>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li class="dropdown">
            <a @click="dropdown('list')" class="dropdown-toggle" data-toggle="dropdown">
              평가관리
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-list">
              <li>
                <a href="/ra_list_v2.do">진행내역</a>
              </li>
              <li>
                <a href="/ra_list_result_v2.do">결과조회</a>
              </li>
            </ul>
          </li>
          <li class="gnb-block">
            <span></span>
          </li>
          <li class="dropdown">
            <a @click="dropdown('cs')" class="dropdown-toggle" data-toggle="dropdown">
              고객센터
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" id="dropdown-cs">
              <li>
                <a href="/note_list_v2.do">공지사항</a>
              </li>
              <li>
                <a href="/cust/faq.do">FAQ</a>
              </li>
              <li>
                <a href="/pds_list_v2.do">자료실</a>
              </li>
              <li>
                <a href="/cust/contact.do">찾아오시는 길</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- /gnb-wrap -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {
      onResultDrop: false,
      onGuideDrop: false,
      onCsDrop: false,
    };
  },
  computed: {
    ...mapGetters("userStore", ["isLogin"]),
    ...mapGetters("userStore", ["isAdmin"]),
    ...mapGetters("userStore", ["getName"]),
    ...mapGetters("userStore", ["getDesc"]),
    ...mapGetters("userStore", ["getAccessToken"]),
  },
  mounted() {},
  methods: {
    logout() {
      if (confirm("로그아웃 하시겠습니까?")) {
        this.$store.dispatch("userStore/LOGOUT");
        alert("로그아웃 되었습니다.");
        this.$router.push("/");
      }
    },
    dropdown(key) {
      const component1 = document.getElementById("dropdown-information");
      const component2 = document.getElementById("dropdown-form");
      const component3 = document.getElementById("dropdown-cs");
      const component4 = document.getElementById("dropdown-list");
      const target = document.getElementById("dropdown-" + key);
      const display = target.getAttribute("style");

      component1.setAttribute("style", "display: none;");
      component2.setAttribute("style", "display: none;");
      component3.setAttribute("style", "display: none;");
      component4.setAttribute("style", "display: none;");

      if (!display || display == "display: none;") {
        target.setAttribute("style", "display: block;");
      }
    },
  },
};
</script>

<style>
a {
  cursor: pointer;
}

.dropdown-on {
  display: block;
}

.dropdown-off {
  display: none;
}
</style>